import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { setInterval } from 'timers';

class Alert extends Component {
    constructor(props) {
        super(props);

        this.refAlert = React.createRef();
        this.state = {
            displayAlert: false,
        }
    }

    setAlertAnime() {
        var counter = 0;
        var min = -2;
        var max = 2;
        let interval = setInterval(() => {
            var a = Math.floor( Math.random() * (max + 1 - min) ) + min ;
            var b = Math.floor( Math.random() * (max + 1 - min) ) + min ;
            this.refAlert.current.style.transform = "translate("+a+"px, "+b+"px)";
            counter++;
            if(counter >= 10){
                clearInterval(interval._id);
            }
        }, 50);
    }

    render() {
        return (
            <Body Display={this.props.display}>
                <Contents ref={this.refAlert}>
                    {this.props.message}
                </Contents>
            </Body>
        );
    }
}

export { Alert }

Alert.propTypes = {
    message: PropTypes.string.isRequired,
    display: PropTypes.bool.isRequired,
};

const Body = styled.div`
    display: ${props => props.Display ? 'block' : 'none'};
    position: relative;
    width: 300px;
`;
const Contents = styled.div`
    position: absolute;
    width: 300px;
    top: 0;
    left: 0;

    border: 1px solid #9B0000;
    background-color: #FFCBCB;
    color: #9B0000;
    padding: 5px 0;
    margin-top: 20px;
    text-align: center;
`;
